/**
 * Whether a URL hash looks like an OAuth/MSAL redirect response
 * (`#state=...&code=...` or `#error=...`).
 *
 * MSAL only removes this from the address bar while a login is in progress.
 * When someone opens a URL that still has it (history, bookmark, shared link)
 * nothing clears it, so we strip it ourselves once MSAL is done.
 *
 * Matches on parsed keys, so hashes the app uses itself (file manager paths,
 * iframe locations, scroll anchors) are left alone.
 */
export function hasAuthResponseHash(hash: string): boolean {
  const params = new URLSearchParams(hash.replace(/^#/, ''));
  return ['code', 'state', 'error', 'error_description'].some((key) => params.has(key));
}
